import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { MATCHES_H2H } from '../../../../../packages/constants/widgetIds';

export const matchesH2HAttributes = getWidgetAttributes(
  MATCHES_H2H,
  [
    WidgetAttributes.WIDGET_SPORT,
    WidgetAttributes.WIDGET_TYPE,
    WidgetAttributes.WIDGET_ID,
    WidgetAttributes.SPORT_ENTITY_ONE,
    WidgetAttributes.SPORT_ENTITY_TWO,
  ],
  [
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.THEME,
    WidgetAttributes.LIMIT,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.LABELS,
    WidgetAttributes.HEADER_DEFAULT_OPTION,
    WidgetAttributes.OPTIONS_DISPLAY,
  ],
);
